/** Emergency-fund progress on the savings screen. */
import { chart } from '@/lib/tokens'

export function ProgressRing({
  ratio,
  size = 160,
  label,
  centerLabel,
  centerValue,
  color = 'var(--color-primary)',
}: {
  ratio: number
  size?: number
  label: string
  centerLabel: string
  centerValue: string
  color?: string
}) {
  const thickness = chart.scoreDialThickness
  const radius = (size - thickness) / 2
  const circumference = 2 * Math.PI * radius
  const swept = Math.max(0, Math.min(1, ratio)) * circumference

  return (
    <div className="score-dial" style={{ width: size, height: size }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} role="img" aria-label={label}>
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="var(--color-scoreTrack)" strokeWidth={thickness} />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={thickness}
          strokeLinecap="round"
          strokeDasharray={`${swept} ${circumference - swept}`}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>
      <span className="score-dial-value" aria-hidden="true">
        <span className="metric-label">{centerLabel}</span>
        <span className="metric-value">{centerValue}</span>
      </span>
    </div>
  )
}
